import { render, staticRenderFns } from "./AddZjAuth.vue?vue&type=template&id=119ea89a&scoped=true&"
import script from "./AddZjAuth.vue?vue&type=script&lang=js&"
export * from "./AddZjAuth.vue?vue&type=script&lang=js&"
import style0 from "./AddZjAuth.vue?vue&type=style&index=0&id=119ea89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119ea89a",
  null
  
)

export default component.exports